import React, { useEffect, useState, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import TimelineIcon from '../assets/Timeline.png';
import '../styles/UserHome.css';
import Notebook from './Notebook';
import TimelineBar from './TimelineBar';
import CaptureMind from './CaptureMind';
import {
  Layout,
  Menu,
  Breadcrumb,
  //Row,
  //Col,
  Spin,
  Alert,
  Avatar,
  Tooltip,
  Button,
  Drawer,
  Grid,
} from 'antd';

import {
  AppstoreOutlined,
  PieChartOutlined,
  DashboardOutlined,
  UserOutlined,
  TeamOutlined,
  HomeOutlined,
  CalendarOutlined,
  DesktopOutlined,
  ShopOutlined,
  HistoryOutlined,
  PoweroffOutlined,
  MenuOutlined,
  FormOutlined
} from '@ant-design/icons';

const { Header, Content, Footer, Sider } = Layout;
const { useBreakpoint } = Grid;

function getItem(label, key, icon, children) {
  return { key, icon, children, label };
}

const items = [
  getItem('Notebook', 'notebook', <FormOutlined />), // ← New item
  getItem('Dashboard', '1', <DashboardOutlined />),
  getItem('AppStore', '2', <AppstoreOutlined />),
  getItem('PieChart', '3', <PieChartOutlined />),
  getItem('Home', '4', <HomeOutlined />),
  getItem('Signals', '5', <DesktopOutlined />),
  getItem('User', '6', <UserOutlined />),
  getItem('Team', 'sub1', <TeamOutlined />, [
    getItem('Rinkss', '7'),
    getItem('Sumsss', '8'),
    getItem('Timsss', '9'),
  ]),
  getItem('Deals', 'sub2', <ShopOutlined />, [
    getItem('Holdings', '10'),
    getItem('Trade History', '11'),
  ]),
  getItem('Event', 'sub3', <CalendarOutlined />, [
    getItem('Today', '12'),
    getItem('All Events', '13'),
  ]),
  getItem('Log', '14', <HistoryOutlined />),
];

const UserHome = () => {
  const { logout, token, decodeToken } = useAuth();
  const [selectedKey, setSelectedKey] = useState('1'); // Default: Dashboard OR we can pick Notebook
  const decodedToken = decodeToken(token);
  console.log('DecodedToken:', decodedToken)
  const [collapsed, setCollapsed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [mobileSiderOpen, setMobileSiderOpen] = useState(false);
  const [notebookVisible, setNotebookVisible] = useState(false);
  const [timelineVisible, setTimelineVisible] = useState(false);


  const screens = useBreakpoint();
  const isMobile = !screens.md;


  useEffect(() => {
    setLoading(true);
    setError(null);
    const fetchData = async () => {
      try {
        await new Promise((res) => setTimeout(res, 500));
      } catch {
        setError('Failed to load data');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  
  const notebookRef = useRef();
  const handleNotebookDrawerClose = async () => {
    if (notebookRef.current?.handleSaveNotes) {
      await notebookRef.current.handleSaveNotes(); // Ensure save before close
    }
    setNotebookVisible(false);
  };

  return (
  <Layout className="user-layout">
    {isMobile ? (
      <Drawer
        closable={false}
        maskClosable={true}
        placement="left"
        onClose={() => setMobileSiderOpen(false)}
        open={mobileSiderOpen}
        width= '65vw'
        styles={{ body: { padding: 0 } }}
      >
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[selectedKey]}
          onClick={({ key }) => {
            setSelectedKey(key);
            setMobileSiderOpen(false); // close drawer on select
          }}
          style={{ flex: 1, overflowY: 'auto'  }}
          items={items}
        />
          <Menu theme="dark" mode="inline" selectable={false}>
            <Menu.Item
              key="logout"
              icon={<PoweroffOutlined />}
              onClick={logout}
              className="logout-menu-item"
            >
              Logout
            </Menu.Item>
          </Menu>
        </div>
      </Drawer>
    ) : (
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        collapsedWidth={60}
        width={180}
        className="user-sider"
      >
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[selectedKey]}
          onClick={({ key }) => setSelectedKey(key)} // ← Update on click
          items={items}
          className="user-menu"
        />
        <Menu theme="dark" mode="inline" selectable={false}>
          <Menu.Item
            key="logout"
            icon={<PoweroffOutlined />}
            onClick={logout}
            className="logout-menu-item"
          >
            Logout
          </Menu.Item>
        </Menu>
      </Sider>
    )}

    <Layout
      className="user-layout-main"
      style={{
        marginLeft: isMobile ? 0 : collapsed ? 60 : 180,
      }}
    >
      <Header
        className="user-header"
        style={{
          left: isMobile ? 0 : collapsed ? 60 : 180,
        }}
      >
        <div className="user-header-left">
          {isMobile && (
            <Button
              icon={<MenuOutlined />}
              type="text"
              onClick={() => setMobileSiderOpen(true)}
            />
          )}
        </div>
        { isMobile ? (
          <Avatar
            size={55}
            icon={<UserOutlined />}
            className="user-avatar"
            onClick={() => setDrawerVisible(true)}
          /> ) : (
          <Tooltip title="My Profile" placement="right">
            <Avatar
              size={55}
              icon={<UserOutlined />}
              className="user-avatar"
              onClick={() => setDrawerVisible(true)}
            /> 
          </Tooltip> )
        }
      </Header>

      <Drawer
        title="My Profile"
        placement="right"
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        width="auto"
        extra={
          <Button
            icon={<PoweroffOutlined style={{ fontSize: 20, color: 'red' }} />}
            danger
            onClick={logout}
            title="Logout"
          />
        }
      >
        {decodedToken ? (
          <>
            <p>
              <strong>Last Active:</strong>{' '}
              {new Date(decodedToken.LastActiveOn).toLocaleString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
              })}
            </p>
            <p><strong>Email:</strong> {decodedToken.Email}</p>
            <p><strong>Name:</strong> {decodedToken.FirstName} {decodedToken.LastName}</p>
            {decodedToken.Details ? (
              (() => {
                const [role, subscription, status] = decodedToken.Details.split('#');
                return (
                  <>
                    <p><strong>Subscription:</strong> {subscription}</p>
                    <p><strong>Role:</strong> {role}</p>
                    <p><strong>Status:</strong> {status}</p>
                  </>
                );
              })()
            ) : (
              <p>Details: N/A</p>
            )}
          </>
        ) : (
          <Spin tip="Loading profile..." />
        )}
      </Drawer>

      <Drawer
        title="Timeline"
        placement="right"
        onClose={() => setTimelineVisible(false)}
        open={timelineVisible}
        width='45%'
      >
        <TimelineBar  CreatedOn={decodedToken?.CreatedOn} />
      </Drawer>
      <Drawer
        title="Notebook"
        placement="right"
        onClose={handleNotebookDrawerClose}
        open={notebookVisible}
        width={isMobile ? '99%' : 450}
      >
        <Notebook ref={notebookRef} />
      </Drawer>

      <Content className="user-content" style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ flex: 1 }}>
          <Breadcrumb style={{ marginBottom: 16 }}>
            <Breadcrumb.Item>User</Breadcrumb.Item>
            <Breadcrumb.Item>
              {selectedKey === 'notebook' ? 'Notebook' : selectedKey === 2 ? 'Capture Mind' : 'Home'}
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className="user-inner-content">
            {loading ? (
              <Spin tip="Loading..." />
            ) : error ? (
              <Alert message="Error" description={error} type="error" showIcon />
            ) : (
              <>
                {selectedKey === 'notebook' ? (
                  <Notebook />
                ) : selectedKey === '2' ? ( // Render InputPage for AppStore
                  <CaptureMind />
                )  : (
                  <div>Welcome to User Home Page</div>
                )}
              </>
            )}
          </div>
        </div>
        {!isMobile && (
          <TimelineBar CreatedOn={decodedToken?.CreatedOn} />
        )}
        </Content>
        
        <div className="microapp-bar">
          { isMobile ? ( 
            <>
              <Button
                shape="circle"
                icon={
                  <img
                    src={TimelineIcon}
                    alt="Timeline"
                    style={{ width: 18, height: 18 }}
                  />
                }
                onClick={() => setTimelineVisible(true)}
              />  
              <Button
                shape="circle"
                icon={<FormOutlined/>}
                onClick={() => setNotebookVisible((prev) => !prev)}
              /> 
            </> ) : (
            <>
              <Tooltip title="Pocket Diary" placement="left">
                <Button
                  shape="circle"
                  icon={<FormOutlined/>}
                  onClick={() => setNotebookVisible((prev) => !prev)}
                />
              </Tooltip> 
            </> )
          }
        </div>


      <Footer className="user-footer">
        Ant Design ©{new Date().getFullYear()} Created by Ant UED
      </Footer>
    </Layout>
  </Layout>

  );
};

export default UserHome;
